export default {
  mounted() {
    this.$nextTick(() => {
      if (this.pageTitle) {
        document.title = `${this.pageTitle} | ECOS AI`;
      }
    });
  },
};
